import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { VrsCallCommentsNonBillableForm } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Textarea } from 'features/ui/elements';

interface CallCommentsControlProps {
  control: Control<VrsCallCommentsNonBillableForm>;
}

export const VrsCallCommentsTextAreaControl: FC<CallCommentsControlProps> = ({
  control,
}) => {
  const maxLength = 1500;

  return (
    <Controller
      control={control}
      name='commentText'
      rules={{ maxLength }}
      render={({ field: { ref, ...args } }) => (
        <Description
          {...args}
          inputProps={{
            maxLength,
            title: 'commentNonBillable',
          }}
        />
      )}
    />
  );
};

const Description = styled(Textarea)`
  margin-top: ${theme.spacing(8)};
`;
